/**
 * Function to sort given string case insensitive
 *
 * @param {string} a First string for comparison
 * @param {string} b Second string for comparison
 *
 * @returns {number} Either a positve or negative number for sorting
 */
export var sortByNameCaseInsensitive = function (a, b) {
    if (a === b)
        return 0;
    return a > b ? 1 : -1;
};
//# sourceMappingURL=sortByNameCaseInsensitive.js.map